/* ==================================================================
   ADAPTIVE FITNESS — Adjustable Edition
   Combined JS for the Shopify homepage section.
   Original source: index.html inline <script> blocks.
   Loads GSAP + ScrollTrigger from cdnjs (referenced in the section
   template) before this file runs.
   ================================================================== */

/* ------------------------------------------------------------------
   1. CUSTOM WHITE-CIRCLE CURSOR
   ------------------------------------------------------------------ */
(function () {
  // Skip on touch / coarse-pointer devices
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var dot = document.getElementById('cursorDot');
  if (!dot) return;

  var x = -100, y = -100;
  var ticking = false;

  function render() {
    dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%, -50%)';
    ticking = false;
  }

  window.addEventListener('mousemove', function (e) {
    x = e.clientX;
    y = e.clientY;
    if (!ticking) {
      requestAnimationFrame(render);
      ticking = true;
    }
  }, { passive: true });

  // Hover-grow on interactive elements
  var hoverSel = 'a, button, [role="button"], input, textarea, select, label, .btn, .toc-cta';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) dot.classList.add('is-hover');
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) dot.classList.remove('is-hover');
  });

  // Hide when cursor leaves the window, show on return
  document.addEventListener('mouseleave', function () { dot.classList.add('is-hidden'); });
  document.addEventListener('mouseenter', function () { dot.classList.remove('is-hidden'); });
})();


/* ------------------------------------------------------------------
   2. PAGE UTILITIES — year, quantity, hero swap, reveal-on-scroll,
      parallax (cutouts + zoom + band backgrounds)
   ------------------------------------------------------------------ */

// Year
(function () {
  var yEl = document.getElementById('year');
  if (yEl) yEl.textContent = new Date().getFullYear();
})();

// Quantity
function adjustQty(delta) {
  const input = document.getElementById('qty');
  if (!input) return;
  const next = Math.max(1, parseInt(input.value || 1, 10) + delta);
  input.value = next;
}

// Product image swap
function swapHero(thumb, src) {
  var heroImg = document.getElementById('hero-img');
  if (heroImg) heroImg.src = src;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// Scroll reveals
(function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

// ===========================================================
// PARALLAX — added 2026-05-24
// 1) Floating cutout images: translate at a fraction of scroll
// 2) Scrubbed zoom sections: scale + drift the photo based on
//    how far the user is through the section.
// All scroll work is rAF-throttled and respects prefers-reduced-motion.
// ===========================================================
(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const floaters = document.querySelectorAll('[data-parallax-speed]');
  const zooms    = Array.from(document.querySelectorAll('.parallax-zoom'));
  // Parallax-band backgrounds get JS-driven parallax on touch devices
  // and small viewports. background-attachment: fixed is broken on iOS
  // Safari (and most touch browsers), so we need the JS path for any
  // touch device regardless of width — iPads in portrait are >720px but
  // still need it. Mouse/desktop keeps the CSS-fixed path.
  const mobileMQ = window.matchMedia('(max-width: 720px), (pointer: coarse)');
  const bandBgs  = Array.from(document.querySelectorAll('.parallax-band .pb-bg'));

  // Per-zoom-section eased state — we lerp toward the scroll-driven
  // target each frame so the photo glides instead of snapping.
  const zoomState = zooms.map(section => ({
    section,
    photo: section.querySelector('.pz-photo'),
    target: 0,   // raw progress (0..1) from scroll
    eased: 0,    // smoothed progress that actually drives transform
  }));

  function readScroll() {
    const vh = window.innerHeight;
    const isMobile = mobileMQ.matches;

    // 0) Parallax-band backgrounds (hero + lower band) — mobile-only
    //    transform parallax, since CSS background-attachment: fixed doesn't
    //    work on iOS. .pb-bg is sized 130%/top:-15% on mobile, so we have
    //    ~15% of section-height of overflow room in each direction.
    bandBgs.forEach(bg => {
      if (!isMobile) {
        // Clear any leftover transform when resizing back to desktop
        if (bg.style.transform) bg.style.transform = '';
        return;
      }
      const section = bg.parentElement;
      if (!section) return;
      const rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return; // offscreen
      // Progress from -0.5 (entering from below) to +0.5 (leaving at top).
      // When section sits centered in viewport, progress = 0.
      const center = rect.top + rect.height / 2;
      const progress = (center - vh / 2) / (vh + rect.height);
      // Translate opposite of scroll so bg appears to lag (parallax).
      const y = -progress * 140; // tuned for visible-but-subtle drift
      bg.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
    });

    // 1) Floating cutouts — move opposite to scroll, slower than page
    floaters.forEach(el => {
      const rect = el.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (center - vh / 2);
      const speed  = parseFloat(el.dataset.parallaxSpeed) || 0.15;
      const y = -offset * speed;
      el.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
    });

    // 2) Scrubbed zoom — just compute the *target* here.
    //    The actual scale/Y is lerped toward it in the rAF loop.
    //    Progress window starts the instant the section enters the
    //    viewport from the bottom (rect.top === vh) and reaches 1 as
    //    the sticky stage releases at the bottom of the section.
    zoomState.forEach(z => {
      const rect = z.section.getBoundingClientRect();
      if (rect.height <= 0) { z.target = 0; return; }
      const range = rect.height; // vh (entry) + (rect.height - vh) (sticky)
      z.target = Math.min(1, Math.max(0, (vh - rect.top) / range));
    });
  }

  // Continuous rAF loop — eases `eased` toward `target` each frame.
  // Lerp factor 0.12 ≈ ~8 frame time-constant @60fps; bump up for
  // snappier, down for silkier. Skip writing transforms when the
  // section is offscreen to keep idle cost near zero.
  const LERP = 0.12;
  function tick() {
    zoomState.forEach(z => {
      if (!z.photo) return;
      const rect = z.section.getBoundingClientRect();
      const onScreen = rect.bottom > 0 && rect.top < window.innerHeight;
      if (!onScreen && Math.abs(z.eased - z.target) < 0.001) return;

      z.eased += (z.target - z.eased) * LERP;
      // Snap when we're effectively there to avoid endless micro-writes.
      if (Math.abs(z.target - z.eased) < 0.0005) z.eased = z.target;

      const p = z.eased;
      const s = 1 + p * 0.6;     // 1.0 → 1.6 (softer than before)
      const y = p * -4;          // gentle drift, 0% → -4%
      z.photo.style.setProperty('--pz-s', s.toFixed(4));
      z.photo.style.setProperty('--pz-y', y.toFixed(3) + '%');
    });
    requestAnimationFrame(tick);
  }

  let scrollScheduled = false;
  function onScroll() {
    if (!scrollScheduled) {
      scrollScheduled = true;
      requestAnimationFrame(() => { readScroll(); scrollScheduled = false; });
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', readScroll);
  readScroll();
  requestAnimationFrame(tick);
})();


/* ------------------------------------------------------------------
   3. PHASE BALL PARALLAX
   Translates .parallax-ball images inside their frames as each
   .weight-card scrolls through the viewport. Same rAF-throttled
   pattern as the rest of the page.
   ------------------------------------------------------------------ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const balls = document.querySelectorAll('.weight-card .parallax-ball');
  if (!balls.length) return;

  // Per-card translation amplitudes (yPercent), slightly varied so the
  // three cards don't drift in perfect lockstep.
  const amps = [28, 34, 24];

  function update() {
    const vh = window.innerHeight;
    balls.forEach((img, i) => {
      const card = img.closest('.weight-card');
      if (!card) return;
      const rect = card.getBoundingClientRect();
      // t: 0 when card top hits viewport bottom, 1 when card bottom leaves viewport top.
      const t = Math.max(0, Math.min(1, (vh - rect.top) / (vh + rect.height)));
      const amp = amps[i % amps.length];
      // yPercent runs from +amp (entering) through 0 (centered) to -amp (leaving).
      const y = amp * (1 - 2 * t);
      img.style.transform = 'translate3d(0,' + y.toFixed(2) + '%,0)';
    });
    ticking = false;
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);
  update();
})();


/* ------------------------------------------------------------------
   4. LITE VIDEO PLAYER (origin story)
   Click thumbnail to load + autoplay video inline.
   Supports both data-video-src (local mp4) and data-video-id (YouTube).
   ------------------------------------------------------------------ */
(function () {
  function play(el) {
    if (el.classList.contains('is-playing')) return;
    var src = el.getAttribute('data-video-src');
    if (src) {
      var video = document.createElement('video');
      video.setAttribute('src', src);
      video.setAttribute('controls', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      el.appendChild(video);
      el.classList.add('is-playing');
      try { video.play(); } catch (e) { /* user can press the built-in control */ }
      return;
    }
    var id = el.getAttribute('data-video-id');
    if (!id) return;
    var iframe = document.createElement('iframe');
    var si = el.getAttribute('data-si') || '';
    var ysrc = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    if (si) { ysrc += '&si=' + encodeURIComponent(si); }
    iframe.setAttribute('src', ysrc);
    iframe.setAttribute('title', el.getAttribute('aria-label') || 'Video player');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    el.appendChild(iframe);
    el.classList.add('is-playing');
  }
  document.querySelectorAll('.origin-video[data-video-id], .origin-video[data-video-src]').forEach(function (el) {
    el.addEventListener('click', function () { play(el); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(el); }
    });
  });
})();


/* ------------------------------------------------------------------
   5. CHAPTER V · IN MOTION — GSAP ScrollTrigger setup (2026-05-25)
   Scroll-driven exercise tour. Requires GSAP + ScrollTrigger loaded
   from cdnjs before this script runs.
   ------------------------------------------------------------------ */
window.addEventListener('load', function () {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn('Chapter V motion section: GSAP failed to load.');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  // Respect reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var section   = document.querySelector('#fullbody.fullbody-motion');
  if (!section) return;
  var frames    = gsap.utils.toArray(section.querySelectorAll('.frame'));
  if (!frames.length) return;
  var gridLayer = section.querySelector('.grid-layer');
  var glowLayer = section.querySelector('.glow-layer');
  var phaseNum  = section.querySelector('#phaseNumber');
  var stepIdx   = section.querySelector('#stepIndex');
  var stepRole  = section.querySelector('#stepRole');
  var phaseName = section.querySelector('#phaseName');
  var progress  = section.querySelector('#progressBar');
  var pct       = section.querySelector('#progressPct');
  var cta       = section.querySelector('#motionCta');

  // role = top label (muscle group), name = bottom label (exercise)
  var phases = [
    { num: '01', role: 'Legs',      name: 'Single Leg Squat'  },
    { num: '02', role: 'Full Body', name: 'Deadlift'          },
    { num: '03', role: 'Back',      name: 'Push Ups'          },
    { num: '04', role: 'Core',      name: 'Cross Body Chops'  },
    { num: '05', role: 'Full Body', name: 'Med Ball Swings'   }
  ];

  gsap.set(frames, { opacity: 0, y: 40, scale: 0.96 });
  gsap.set(frames[0], { opacity: 1, y: 0, scale: 1 });

  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.8,
      pin: '.stage',
            invalidateOnRefresh: true
    }
  });
    var refreshScroll=function(){if(window.ScrollTrigger)window.ScrollTrigger.refresh();};var resizeTimer;window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(refreshScroll,250);});window.addEventListener('orientationchange',refreshScroll);

  for (var i = 1; i < frames.length; i++) {
    var segmentStart = (i - 1) / (frames.length - 1);
    tl.to(frames[i - 1], { opacity: 0, y: -30, scale: 1.02, ease: 'none', duration: 0.2 }, segmentStart);
    tl.fromTo(frames[i],
      { opacity: 0, y: 40, scale: 0.96 },
      { opacity: 1, y: 0,  scale: 1,    ease: 'none', duration: 0.2 },
      segmentStart
    );
  }

  tl.to(gridLayer, { yPercent: -6, ease: 'none', duration: 1 }, 0);
  tl.to(glowLayer, { yPercent: -12, xPercent: 4, ease: 'none', duration: 1 }, 0);
  tl.to(section.querySelector('.phase-number'), { yPercent: -10, ease: 'none', duration: 1 }, 0);

  tl.fromTo(cta,
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, ease: 'power2.out', duration: 0.15 },
    0.85
  );

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    onUpdate: function (self) {
      var p = self.progress;
      var idx = Math.min(frames.length - 1, Math.floor(p * frames.length));
      var ph = phases[idx];
      if (phaseNum.textContent !== ph.num) phaseNum.textContent = ph.num;
      if (stepIdx.textContent  !== ph.num) stepIdx.textContent  = ph.num;
      if (stepRole.textContent !== ph.role) stepRole.textContent = ph.role;
      if (phaseName.textContent !== ph.name) phaseName.textContent = ph.name;
      progress.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      pct.textContent = String(Math.round(p * 100)).padStart(2, '0') + '%';
    }
  });

  gsap.from(section.querySelectorAll('.copy .eyebrow, .copy h2, .copy p'), {
    y: 30, opacity: 0, duration: 0.9, stagger: 0.12, ease: 'power3.out',
    scrollTrigger: { trigger: section, start: 'top 70%' }
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }
});

// Mobile menu toggle — 2026-05-26
(function () {
  var toggle = document.getElementById('navToggle');
    if (!toggle) return;
      toggle.addEventListener('click', function (e) {
          e.stopPropagation();
              document.body.classList.toggle('nav-open');
                });
                  document.querySelectorAll('.nav-links a').forEach(function (link) {
                      link.addEventListener('click', function () {
                            document.body.classList.remove('nav-open');
                                });
                                  });
                                    document.addEventListener('click', function (e) {
                                        if (!document.body.classList.contains('nav-open')) return;
                                            if (e.target.closest('.nav-links') || e.target.closest('.nav-toggle')) return;
                                                document.body.classList.remove('nav-open');
                                                  });
                                                    document.addEventListener('keydown', function (e) {
                                                        if (e.key === 'Escape') document.body.classList.remove('nav-open');
                                                          });
                                                          })();